export default __webpack_public_path__ + "static/media/graph.00face2d.png";